import axios from "axios";
import Cookies from "js-cookie";
import { getErrorMessages } from "@utils/getErrorMessages";
import { getErrorMessagesV2 } from "@utils/getErrorMessagesV2";
import { renderErrorMessages } from "@utils/renderErrorMessages";
import router from "../router/router";
import { RouterPaths } from "../router/routerPaths";

const request = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 10000,
});

request.interceptors.request.use(
    config => {
        const token = Cookies.get("token");

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        const status = error?.response?.status;
        const message = error?.response?.data || error?.message;
        if (status === 422) {
            // renderErrorMessages(getErrorMessages(error.response.data));
            renderErrorMessages(getErrorMessagesV2(error.response.data));
            return Promise.reject(error);
        }
        if (status === 403 || message === "Forbidden") {
            router.navigate(RouterPaths.DASHBOARD);
            return Promise.reject(error);
        }

        // if(error.message === "timeout of 10000ms exceeded" || error.status === 500 ) {
        //     window.location.href = RouterPaths.ERRORFALLBACK;
        // }

        return Promise.reject(error);
    }
);

export default request;
